<template>
  <ul class="sidebar-menu">
    <li class="sidebar-menu__section" v-for="(section, i) in newMenuItems" :key="i">
      <m4-heading level="3" v-if="section.title">{{ section.title }}</m4-heading>
      <ul v-if="section.items != undefined && section.items.length" class="sidebar-menu__section__items">
        <li class="sidebar-menu__section__item" v-for="(item, j) in section.items" :key="i + '_' + j">
          <m4-button
            :variant="'default-text ' + (item.active && 'active') + (isOpenedItem(item) ? ' opened' : '')"
            size="full-width"
            :class="'sidebar-menu__section__item__button'"
            v-bind="itemButtonProps(item)"
            @click="onClickItem(item)"
          >
            <m4-level no-gutters>
              <m4-level-left>
                <m4-icon icon="tachometer" v-if="item.home"></m4-icon>
                <m4-icon icon="folder" v-else-if="item.items && item.items.length"></m4-icon>
                <m4-icon icon="list-alt" v-else></m4-icon>
                {{ item.text }}
              </m4-level-left>
              <m4-level-right>
                <m4-icon icon="angle-down" v-if="item.items && item.items.length"></m4-icon>
              </m4-level-right>
            </m4-level>
          </m4-button>
          <ul
            v-if="item.items && item.items.length > 0"
            :class="
              'sidebar-menu__section__items__children' + (isOpenedItem(item) ? ' sidebar-menu__children--opened' : '')
            "
          >
            <li
              class="sidebar-menu__section__items__children__item"
              v-for="(childItem, k) in item.items"
              :key="i + '_' + j + '_' + k"
            >
              <m4-button
                :variant="'default-text ' + (childItem.active && 'active')"
                size="full-width"
                class="sidebar-menu__section__item__button"
                v-bind="itemButtonProps(childItem)"
                @click="onClickItem(childItem)"
              >
                <m4-icon icon="list-alt"></m4-icon>{{ childItem.text }}
              </m4-button>
            </li>
          </ul>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
export default {
  name: "M4SidebarMenu",
  data() {
    return {
      newMenuItems: this.menuItems
    };
  },
  props: {
    menuItems: Array
  },
  methods: {
    isOpenedItem(item) {
      return (item.active && item.opened === undefined) || item.opened;
    },
    onClickItem(item) {
      if (item.items) {
        this.newMenuItems = this.newMenuItems.map((section) => {
          section = Object.assign({}, section, {
            items: section.items.map((menuItem) => {
              if (item === menuItem) {
                menuItem = Object.assign({}, menuItem, {
                  opened: menuItem.opened !== undefined ? !menuItem.opened : !menuItem.active
                });
              }
              return menuItem;
            })
          });
          return section;
        });
      }
    },
    itemButtonProps(item) {
      if (item.to) {
        return {
          tag: "router-link",
          to: item.to
        };
      } else if (item.href) {
        return {
          tag: "a",
          href: item.href
        };
      }
      return {
        tag: "a"
      };
    }
  }
};
</script>
